import {Widget} from '@dv5/domain'
import {WidgetDragPosition} from '../../model/DragState'

export const getDraggedWidgets = (
    draggedWidgetId: string,
    selection: Array<string>,
    widgets: Array<Widget>,
): WidgetDragPosition[] => {
    const idsToMove = selection.includes(draggedWidgetId) ? selection : [draggedWidgetId]
    return widgets
        .filter(widget => idsToMove.includes(widget.id) && !widget.locked)
        .map(widget => ({id: widget.id, left: widget.left, top: widget.top}))
}

export const moveWidgetPositions = (
    draggedWidgets: WidgetDragPosition[],
    deltaX: number,
    deltaY: number,
): WidgetDragPosition[] =>
    draggedWidgets.map(({id, left, top}) => ({
        id,
        left: Math.max(0, left + deltaX),
        top: Math.max(0, top + deltaY),
    }))
